import { normaliseToShiftTimesSeconds } from '@/helpers/dateHelper';
import { useSystemSettings } from '@/services/settings/SystemSettingsProvider';
import { strings } from '@/services/translation/strings';
import { useLocation } from '@/services/useLocations';
import { useMemo } from 'react';

export const useLocationDefaultTimes = (locationId: number) => {
  const { location, fetching } = useLocation(locationId);
  const defaultTenantShiftTimes = useSystemSettings(s => s.settings.defaultShiftTimes);
  const defaultRosterMinStartTime = useSystemSettings(s => s.settings.minTime);
  const defaultRosterMaxEndTime = useSystemSettings(s => s.settings.maxTime);

  const { defaultShiftTimes, defaultRosterTimes, defaultOpeningTimes } = useMemo(() => {
    const properties = JSON.parse(location.properties ?? '{}');

    const defaultShiftTimes = normaliseToShiftTimesSeconds(properties.defaultShiftTimes ?? defaultTenantShiftTimes);

    const defaultRosterTimes = normaliseToShiftTimesSeconds(
      properties.defaultRosterTimes ??
        Object.fromEntries(
          strings.common.daysOfWeekFullStartMonday.map(day => [
            day.toLowerCase(),
            { start: defaultRosterMinStartTime, end: defaultRosterMaxEndTime }
          ])
        )
    );

    const defaultOpeningTimes = normaliseToShiftTimesSeconds(properties.defaultOpeningTimes ?? defaultTenantShiftTimes);

    return { defaultShiftTimes, defaultRosterTimes, defaultOpeningTimes };
  }, [location.properties, defaultTenantShiftTimes, defaultRosterMinStartTime, defaultRosterMaxEndTime]);

  return { fetching, defaultShiftTimes, defaultRosterTimes, defaultOpeningTimes };
};
